// extracted by css-extract-rspack-plugin
export default {"adminBadge":"CommentBody_adminBadge__HF0An","timestamp":"CommentBody_timestamp__+cAa-","displayName":"CommentBody_displayName__n6cy8"};